const SESSION_OVERRIDE_KEY = "environmentOverrideSettings";

function generalDefaults() {
  return {
    appVersion:
      process.env.REACT_APP_VERSION ||
      process.env.REACT_APP_APP_VERSION ||
      process.env.npm_package_version ||
      "0.1.0",
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "",
    assetsBaseUrl: process.env.REACT_APP_ASSETS_BASE_URL || "",
  };
}

function defaultShowEnvironmentInfo() {
  if (process.env.REACT_APP_SHOW_ENVIRONMENT_INFO !== undefined) {
    return process.env.REACT_APP_SHOW_ENVIRONMENT_INFO !== "false";
  }
  if (process.env.NODE_ENV === "production") return false;
  return true;
}

function profileDefaults() {
  return {
    name:
      process.env.REACT_APP_ENV_NAME ||
      process.env.REACT_APP_ENV_ID ||
      process.env.NODE_ENV ||
      "Environment",
    color: process.env.REACT_APP_ENV_BAR_COLOR || "#0369a1",
    showEnvironmentInfo: defaultShowEnvironmentInfo(),
    appDefaultBehavior: "LASHBROOK ADMIN",
  };
}

function readSessionOverride() {
  if (typeof sessionStorage === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(SESSION_OVERRIDE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function readWindowOverrides() {
  if (typeof window === "undefined" || !window.environmentSettings) return {};
  const w = window.environmentSettings;
  return w && typeof w === "object" ? w : {};
}

/**
 * Merge: general → profile defaults → window.environmentSettings → session.
 */
export function getMergedEnvironmentConfig() {
  const merged = {
    ...generalDefaults(),
    ...profileDefaults(),
    ...readWindowOverrides(),
    ...readSessionOverride(),
  };

  return merged;
}

export function shouldShowEnvironmentInfoFromConfig(value) {
  if (value === false || value === "false") return false;
  return true;
}
